var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGiftTwo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "M20.11 9.388H4.671a.813.813 0 0 0-.813.812v2.438a.812.812 0 0 0 .813.812h15.437a.812.812 0 0 0 .813-.812V10.2a.812.812 0 0 0-.813-.812Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7B546",
  d: "M20.11 9.388h-1.626a.812.812 0 0 1 .813.812v2.438a.811.811 0 0 1-.813.812h1.625a.812.812 0 0 0 .813-.812V10.2a.812.812 0 0 0-.813-.812Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "M13.203 13.45h6.094v8.938a.812.812 0 0 1-.813.812H6.297a.812.812 0 0 1-.813-.812V13.45h6.094"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7B546",
  d: "M17.672 13.45H5.484v1.625h8.938a3.25 3.25 0 0 1 3.25 3.25V23.2h.812a.812.812 0 0 0 .813-.812V13.45h-1.625Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F04C4D",
  d: "M10.36 5.325a2.031 2.031 0 1 0 0 4.063h2.03V7.356a2.031 2.031 0 0 0-2.03-2.03Zm1.218 3.25H10.36a1.219 1.219 0 1 1 1.22-1.219v1.22Zm2.844-3.25a2.031 2.031 0 0 0-2.031 2.031v2.032h2.03a2.031 2.031 0 0 0 0-4.063Zm0 3.25h-1.219V7.356a1.219 1.219 0 1 1 1.219 1.22Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E13340",
  d: "M14.422 8.575h.406a1.219 1.219 0 1 0 0-2.437c-.07 0-.136.009-.203.02a1.216 1.216 0 0 1-.203 2.417Zm-4.063-2.437h-.406a1.219 1.219 0 1 0 0 2.437c.07 0 .137-.009.203-.02a1.216 1.216 0 0 1 .203-2.417Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F04C4D",
  d: "M11.578 9.388h1.625V23.2h-1.625V9.388Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "m18.403 4.431 1.3-.325-1.3-.325-.325-1.3-.325 1.3-1.3.325 1.3.325.325 1.3.325-1.3Zm1.463 2.275.65-.162-.65-.163-.163-.65-.162.65-.65.163.65.162.162.65.163-.65Zm.812-3.25.65-.162-.65-.163-.162-.65-.163.65-.65.163.65.162.163.65.162-.65Z"
})));
export default SvgGiftTwo;